import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const TvSpeakerIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-tvSpeaker"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M7.7071 24.2929C5.5241 22.4579 4.0001 19.9109 4.0001 16.9999 4.0001 14.0889 5.5241 11.5429 7.7071 9.7069 8.6931 8.8779 7.2721 7.4689 6.2931 8.2929 3.7201 10.4569 2.0001 13.5929 2.0001 16.9999 2.0001 20.4069 3.7201 23.5429 6.2931 25.7069 7.2721 26.5309 8.6941 25.1229 7.7071 24.2929M61.7071 25.7071C64.2801 23.5431 66.0001 20.4071 66.0001 17.0001 66.0001 13.5931 64.2801 10.4571 61.7071 8.2931 60.7281 7.4691 59.3061 8.8771 60.2931 9.7071 62.4751 11.5421 64.0001 14.0891 64.0001 17.0001 64.0001 19.9111 62.4751 22.4571 60.2931 24.2931 59.3071 25.1221 60.7281 26.5311 61.7071 25.7071"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M9.7071 20.2929C9.1221 19.7989 8.7261 19.3459 8.3881 18.6729 8.1391 18.1769 8.0001 17.5659 8.0001 16.9999 8.0001 16.8449 8.0091 16.6899 8.0231 16.5349 8.0311 16.4639 8.0301 16.4659 8.0201 16.5439 8.0251 16.5089 8.0311 16.4749 8.0371 16.4409 8.0541 16.3559 8.0701 16.2699 8.0891 16.1859 8.1681 15.8469 8.2571 15.5939 8.3631 15.3759 8.7041 14.6799 9.1081 14.2129 9.7071 13.7069 10.1201 13.3589 10.0661 12.6519 9.7071 12.2929 9.2981 11.8839 8.7071 11.9429 8.2931 12.2929 6.9111 13.4599 6.0001 15.1699 6.0001 16.9999 6.0001 18.8299 6.9111 20.5399 8.2931 21.7069 8.7051 22.0549 9.3031 22.1119 9.7071 21.7069 10.0641 21.3499 10.1221 20.6429 9.7071 20.2929M59.7071 21.7071C61.0891 20.5401 62.0001 18.8301 62.0001 17.0001 62.0001 15.1701 61.0891 13.4601 59.7071 12.2931 59.2951 11.9451 58.6971 11.8881 58.2931 12.2931 57.9351 12.6501 57.8781 13.3571 58.2931 13.7071 58.8781 14.2011 59.2731 14.6541 59.6121 15.3271 59.8611 15.8231 60.0001 16.4341 60.0001 17.0001 60.0001 17.1551 59.9901 17.3101 59.9771 17.4651 59.9691 17.5361 59.9701 17.5341 59.9801 17.4561 59.9741 17.4911 59.9691 17.5251 59.9631 17.5591 59.9461 17.6441 59.9301 17.7301 59.9101 17.8141 59.8311 18.1531 59.7431 18.4061 59.6361 18.6241 59.2961 19.3201 58.8921 19.7871 58.2931 20.2931 57.8801 20.6411 57.9341 21.3481 58.2931 21.7071 58.7021 22.1161 59.2931 22.0571 59.7071 21.7071"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M50,6 L18,6 C16.3427153,6 15,7.34271525 15,9 L15,25 C15,26.6572847 16.3427153,28 18,28 L50,28 C51.6572847,28 53,26.6572847 53,25 L53,9 C53,7.34271525 51.6572847,6 50,6 Z M18,8 L50,8 C50.5527153,8 51,8.44728475 51,9 L51,25 C51,25.5527153 50.5527153,26 50,26 L18,26 C17.4472847,26 17,25.5527153 17,25 L17,9 C17,8.44728475 17.4472847,8 18,8 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M39.5 26 28.5 26C27.6718576 26 27 26.6718576 27 27.5L27 29.5C27 30.3281424 27.6718576 31 28.5 31L39.5 31C40.3281424 31 41 30.3281424 41 29.5L41 27.5C41 26.6718576 40.3281424 26 39.5 26ZM28.5 27 39.5 27C39.7758576 27 40 27.2241424 40 27.5L40 29.5C40 29.7758576 39.7758576 30 39.5 30L28.5 30C28.2241424 30 28 29.7758576 28 29.5L28 27.5C28 27.2241424 28.2241424 27 28.5 27ZM22.5 9C22.7761424 9 23 9.22385763 23 9.5 23 9.74545989 22.8231248 9.94960837 22.5898756 9.99194433L22.5 10 19 10 19 12.5C19 12.7454599 18.8231248 12.9496084 18.5898756 12.9919443L18.5 13C18.2545401 13 18.0503916 12.8231248 18.0080557 12.5898756L18 12.5 18 9.645C18 9.28829545 18.2783747 9.04708678 18.5965815 9.00617863L18.693 9 22.5 9Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
